import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon.js';
import Card from '../Card/Card.js';
import styles from './SortableList.module.scss.js';

function DefaultItemWrapper(_ref) {
  var children = _ref.children,
    isDraggable = _ref.isDraggable;
  return /*#__PURE__*/React.createElement(Card, {
    className: styles.draggableItem
  }, children, isDraggable && /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-drag",
    size: "medium",
    className: styles.icon
  }));
}
DefaultItemWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isDraggable: PropTypes.bool
};
DefaultItemWrapper.defaultProps = {
  isDraggable: true
};

export { DefaultItemWrapper };
